import { AnimatePresence, HTMLMotionProps, motion } from "framer-motion";
import { classNames } from "primereact/utils";
import React from "react";

export const ErrorMessage: React.FC<HTMLMotionProps<"div">> = ({ children, className, ...props }) => (
	<AnimatePresence>
		{!!children && (
			<motion.div
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				exit={{ opacity: 0 }}
				className={classNames("p-error", className)}
				{...props}
			>
				{children}
			</motion.div>
		)}
	</AnimatePresence>
);
